var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.1924 10C19.1924 15.0768 15.0768 19.1924 10 19.1924C4.92319 19.1924 0.807617 15.0768 0.807617 10C0.807617 4.92319 4.92319 0.807617 10 0.807617C15.0768 0.807617 19.1924 4.92319 19.1924 10ZM3.56533 10C3.56533 13.5538 6.44623 16.4347 10 16.4347C13.5538 16.4347 16.4347 13.5538 16.4347 10C16.4347 6.44623 13.5538 3.56533 10 3.56533C6.44623 3.56533 3.56533 6.44623 3.56533 10Z",
    fill: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77604 0.889455C10.2138 0.6963 11.6768 0.846159 13.0455 1.32677C14.4143 1.80739 15.6498 2.60512 16.6512 3.65474L14.6558 5.55832C13.9549 4.82358 13.09 4.26517 12.1319 3.92874C11.1738 3.59231 10.1496 3.48741 9.14323 3.62262L8.77604 0.889455Z",
    fill: "#00B840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.1681b79be07b48d9626c944691d3ddba.svg";
export { ForwardRef as ReactComponent };